<template>
<div class="fluid page_content db_lyt_v22 adviosr_learner_home">
  <div class="col-12 sec_content self_reported_courses">
    <div class="row accordion">
      <div class="col-12 accordion_crd">
        <b-card-header header-tag="header" class="row sec_hd sec_hd_l1" role="tab" block variant="info" v-b-toggle="'course_sec_1'">
          <div class="col-1 ic_container">
            <div class="ic ic-expand_r"></div>
            <div class="ic ic-collapse_r"></div>
          </div>
          <div class="col-11 hd_txt hd_sec2">
            <div class="row">
              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 title">{{parentTitle}}</div>
              <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 progress_bar_sec">
                <div class="col-12" v-if="(((courses.length > 0 && parent.total>1)|| (parentTitle.indexOf('Exam') !=-1 && parent.total>1)))">
                  <program-category-score-and-progress-bar hideScoreForStudent="false" :performance="parent.performance" :completeCount="parent.completed"
                    :totalCount="parent.total" :inProgressCount="parent.inProgress">
                  </program-category-score-and-progress-bar>
                </div>
                <div class="col-12 progress_info_sec" v-else-if="!parent.planningStream && parent.total===1">
                  <div class="txt_container completed" v-if="parent.total === parent.completed">
                    <div class="ic_container">
                      <span class="ic ic26-completed"></span>
                    </div>
                    <div class="status_info">
                      <span>Completed</span>
                    </div>
                  </div>
                  <div class="txt_container pending" v-else>
                    <div class="ic_container">
                      <span class="ic ic24-hour-glass"></span>
                    </div>
                    <div class="status_info">
                      <span>Pending</span>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </b-card-header>

        <div class="row">
          <div class="col-12">
            <b-collapse id="course_sec_1" visible role="tabpanel" class="row course_list_container my_program_status">
              <!-- Handle this in another component -->
              <template v-for="(course, index) in courses">

                <template v-if="course.entityType === 'folder'">
                  <div class="col-12 course_row_l1" :class="'node_row_' + index">
                    <div class="row accordion">
                    <div class="col-12 accordion_crd">
                      <b-card-header header-tag="header" class="row sec_hd" role="tab" block v-b-toggle="course.uuid" variant="info">
                        <div class="col-1 ic_container">
                          <div class="ic ic-expand_r"></div>
                          <div class="ic ic-collapse_r"></div>
                        </div>
                        <div class="col-11 hd_txt hd_sec2">
                          <div class="row">
                            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 title">{{course.title}}</div>
                            <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 progress_bar_sec">
                              <div class="col-12" v-if="((getCoursesFromFolder(course).length > 0 || (course.title.indexOf('Exam') !=-1 && course.total>1)))">
                                <program-category-score-and-progress-bar hideScoreForStudent="false" :performance="course.performance" :completeCount="course.completed"
                                  :totalCount="course.total" :inProgressCount="course.inProgress">
                                </program-category-score-and-progress-bar>

                              </div>
                              <div class="col-12 progress_info_sec" v-else-if="!course.planningStream">
                                <div class="txt_container completed" v-if="course.total === course.completed">
                                  <div class="ic_container">
                                    <span class="ic ic26-complete"></span>
                                  </div>
                                  <div class="status_info">
                                    <span>Completed</span>
                                  </div>
                                </div>
                                <div class="txt_container pending" v-else>
                                  <div class="ic_container">
                                    <span class="ic ic24-hour-glass"></span>
                                  </div>
                                  <div class="status_info">
                                    <span>Pending</span>
                                  </div>
                                </div>

                              </div>
                            </div>
                          </div>
                        </div>
                      </b-card-header>
                      <div class="row">
                        <div class="col-12">
                          <b-collapse :id="course.uuid" visible role="tabpanel" class="row course_list_container my_program_status">
                            <template v-for="subCourse in getCoursesFromFolder(course)">
                              <div class="col-12 course_row" :key="subCourse.originUuid" :class="subCourse.waiveStatus ? 'waived_course_row' : ''" v-if="(subCourse.entityType !== 'folder')">

                                <div class="row">
                                  <div class="title" :class="(subCourse.entityType === 'deliverycontext') ? 'col-6' : 'col-6'" :style="{cursor: (subCourse.entityType === 'deliverycontext') ? 'pointer' : 'default'}" @click="pObject.openLearnerCourseReportModal(subCourse)">
                                    <div class="thumbnail_sec">
                                      <div class="thumbnail" :style="{background: setThumbnailBgColor(subCourse.uuid)}">
                                        <div v-html="setThumbnailTitle(subCourse)"></div>
                                      </div>
                                      <template v-if="(subCourse.entityType === 'catalog')">
                                        <div class="credit_info">
                                          {{subCourse.creditsEarned}} credits
                                        </div>
                                      </template>
                                    </div>
                                    <div class="col_title">
                                      <div>{{subCourse.title}}</div>
                                    </div>
                                  </div>
                                  <template v-if="(subCourse.entityType === 'deliverycontext')">
                                    <div class="col-6 progress_bar entity_row_detail_sec">
                                      <div class="row">
                                        <div class="col-2 lnk_container" style="margin-top: 2px; padding-right: 0px;">
                                          <template v-if="pObject.customAdvisorWaive()" >
                                          <b-link class="btn_waive" @click="pObject.openWaiveDetailModal(subCourse, false)" v-if="(!subCourse.waiveStatus)" title="Course is Not Waived" v-b-tooltip.hover>
                                            <span class="ic ic22-cog"></span>
                                          </b-link>
                                          <b-link class="btn_waive" @click="pObject.openWaiveDetailModal(subCourse, true)" v-if="(subCourse.waiveStatus)" title="Course is Waived" v-b-tooltip.hover>
                                            <!--span class="course_w">W</span-->
                                            <span class="ic ic22-cog"></span>
                                          </b-link>
                                          </template>
                                          <template v-if="pObject.customAdvisorUnlock()">
                                            <b-link class="btn_lock_unlock" @click="pObject.openReleaseDetailModal(subCourse, false)" v-if="(!subCourse.releaseStatus)" title="Course is Locked" v-b-tooltip.hover>
                                              <span class="ic ic22-lock"></span>
                                            </b-link>
                                            <b-link class="btn_lock_unlock" @click="pObject.openReleaseDetailModal(subCourse, true)" v-if="(subCourse.releaseStatus && subCourse.releaseLogicDetail && subCourse.releaseLogicDetail.length>1)" title="Course is Unlocked" v-b-tooltip.hover>
                                              <span class="ic ic22-unlock"></span>
                                            </b-link>
                                            </template>
                                        </div>

                                        <div class="col-10 pl-0">
                                          <advisee-program-course-score-and-progress :course-id="subCourse.originUuid" :user-id="learnerUserId" :pObject="pObject" :course="course" @progressSummary="aggregateProgressSummary"></advisee-program-course-score-and-progress>
                                        </div>
                                      </div>
                                    </div>
                                  </template>
                                  <template v-if="(subCourse.entityType === 'catalog')">
                                    <div class="col-6 progress_status" style="margin-bottom: 16px;">
                                      <div class="row">
                                        <div class="col-2 lnk_container" style="margin-top: 2px; padding-right: 0px;"></div>
                                        <div class="col-10 pl-0">
                                          <div class="row">
                                            <div class="col-7"></div>
                                            <div class="col-5 btn_container float-right">
                                              <b-button :class="courseStatusBackgroundMap[subCourse.courseStatus]" style="cursor: default; height: 32px; padding-top: 5px;">
                                                <div style="color: #fff;">{{courseStatusMap[subCourse.courseStatus]}}</div>
                                              </b-button>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </template>
                                </div>
                              </div>
                              <learner-courses :parent="subCourse" :pObject="pObject" :parentTitle="subCourse.title" :learnerUserId="learnerUserId" :formattedProgramGuide="formattedProgramGuide" :courses=getCoursesFromFolder(subCourse) v-if="(subCourse.entityType === 'folder')">
                              </learner-courses>

                            </template>
                          </b-collapse>
                        </div>
                      </div>
                    </div>
                  </div>
                  </div>
                </template>
                <template v-if="course.entityType !== 'folder'">
                  <div class="col-12 course_row"  :key="course.originUuid"  :class="course.waiveStatus ? 'waived_course_row' : ''">

                    <div class="row">
                      <div class="title" :class="(course.entityType === 'deliverycontext') ? 'col-6' : 'col-8'" :style="{cursor: (course.entityType === 'deliverycontext') ? 'pointer' : 'default'}" @click="pObject.openLearnerCourseReportModal(course)">
                        <div class="thumbnail_sec">
                          <div class="thumbnail" :style="{background: setThumbnailBgColor(course.uuid)}">
                            <div v-html="setThumbnailTitle(course)"></div>
                          </div>
                          <template v-if="(course.entityType === 'catalog')">
                            <div class="credit_info">
                              {{course.creditsEarned}} credits
                            </div>
                          </template>
                        </div>
                        <div class="col_title">
                          <div>{{course.title}}</div>
                        </div>
                      </div>
                      <template v-if="(course.entityType === 'deliverycontext')">
                        <div class="col-6 progress_bar entity_row_detail_sec">
                          <div class="row">
                            <div class="col-2 lnk_container" style="margin-top: 2px; padding-right: 0px;">
                              <div class="row">
                                <div class="col-6">
                                <template v-if="pObject.customAdvisorUnlock()" >
                                  <b-link class="btn_lock_unlock" @click="pObject.openReleaseDetailModal(course, false)" v-if="(!course.releaseStatus)">
                                    <span class="ic22-lock"></span>
                                  </b-link>
                                  <b-link class="btn_lock_unlock" @click="pObject.openReleaseDetailModal(course, true)" v-if="(course.releaseStatus && course.releaseLogicDetail && course.releaseLogicDetail.length>1)">
                                    <span class="ic22-unlock"></span>
                                  </b-link>
                                </template>
                                </div>
                                <div class="col-6">
                                <template v-if="pObject.customAdvisorWaive()" >
                                  <b-link class="row_settings" @click="pObject.openWaiveDetailModal(course, false)" v-if="(!course.waiveStatus)">
                                    <span class="ic ic24-cog"></span>
                                  </b-link>
                                  <b-link class="row_settings" @click="pObject.openWaiveDetailModal(course, true)" v-if="(course.waiveStatus)">
                                    <span class="ic ic24-cog"></span>
                                  </b-link>
                                </template>
                                </div>
                              </div>
                            </div>

                            <div class="col-10 pl-0">
                              <advisee-program-course-score-and-progress :course-id="course.originUuid" :user-id="learnerUserId" :pObject="pObject" :course="course" @progressSummary="aggregateProgressSummary"></advisee-program-course-score-and-progress>

                              <div class="course_waived_status">
                                <template v-if="(!course.waiveStatus)">
                                  <span class="">Not Waived</span>
                                </template>
                                <template v-if="(course.waiveStatus)">
                                  <span class="">Waived</span>
                                </template>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>

                      <div class="col-4 progress_status" style="margin-bottom: 16px;">
                        <template v-if="(course.entityType === 'catalog')">
                          <div class="row">
                            <div class="col-6"></div>
                            <div class="col-6 btn_container float-right pl-0">
                              <b-button :class="courseStatusBackgroundMap[course.courseStatus]" style="cursor: default;">
                                <div style="color: #fff;">{{courseStatusMap[course.courseStatus]}}</div>
                              </b-button>
                            </div>
                          </div>
                        </template>


                      </div>

                    </div>
                  </div>
                </template>
              </template>
              <!-- Handle this in another component ends -->
            </b-collapse>
          </div>
        </div>
      </div>
    </div>
  </div>
    <div class="modal_popup_container course_unlock_modal">
      <b-modal ref="learnerCourseReleaseModal" class="description_modal" size="md" id="course-report-popup" hide-footer >
      </b-modal>
    </div>
</div>
</template>

<script>
  import _ from 'lodash'
  import { DateTime } from 'luxon'
  import { mapState, mapActions } from 'vuex'
  import { PACKAGE } from '../../../package_constants'
  import { PackageUtil } from '../../../package_utils'
  import AdviseeProgramCourseScoreAndProgress from './AdviseeProgramCourseScoreAndProgress'
  import ProgramCategoryScoreAndProgressBar from '../../programguide/components/ProgramCategoryScoreAndProgressBar'

  import StudentMyReport from '../../course/components/StudentMyReport'

  export default {
    name: 'learner-courses',
    props: ['courses', 'parent', 'parentTitle', 'formattedProgramGuide','learnerUserId', 'pObject'],
    components: {
      StudentMyReport,
      AdviseeProgramCourseScoreAndProgress,
      ProgramCategoryScoreAndProgressBar
    },
    data: () => {
      return {
        advisee: {},
        adviseeTags: [],
        calendarEvents: [],
        isDataLoaded: false,
        selectedNoteType: 'Shared',
        enrolledPrograms: [],
        selectedProgram: null,
        modalHeaderLabel: '',
        courseStatusMap: {
          0: 'Not Started',
          1: 'In Progress',
          2: 'Completed',
          7: 'Couldn\'t Complete'
        },
        courseStatusBackgroundMap: {
          0: 'status-not-started',
          1: 'status-in-progress',
          2: 'status-completed',
          7: 'status-not-completed'
        },
        reportModalHeaderLabel: '',
        selectedCourseForReporting: null,
        selectedCourseForRelease: null,
        releaseModalHeaderLabel:'',
        releaseLogicDetail : '',
        releaseStatus : true,
        releaseStatusUpdatedBy : 'System',
        releaseStatusUpdatedTime: undefined,
        selectedCourseForReleaseTitle : '',
        selectedCourseForWaive: null,
        waiveModalHeaderLabel:'',
        waiveLogicDetail : '',
        waiveScore : '',
        waiveStatus : false,
        waiveStatusUpdatedBy : 'System',
        waiveStatusUpdatedTime: undefined,
        selectedCourseForWaiveTitle : ''

      }
    },
    mounted () {

    },
    methods: {
      ...mapActions([
        'loadAdviseeDetail',
        'loadPersonTags',
        'loadStreamWithStructure',
        'loadLearnerEnrollmentData',
        'loadFutureCalendarEventsForParticipant',
        'loadMicroCompetencyProgressForSelectedUser',
        'releaseCourse',
        'waiveCourse',
        'unenrollFromProgram',
        'loadStreamWithStructureSummary',
        'reProcessProgramEnrollment'

      ]),
      resetData (data) {
        data.score = 0
        data.courses = []
        data.performance = 0
        data.childrenCount = 0
        data.childrenCompleteCount = 0
        data.progressSummaryCount = 0
        data.isScoreNotAvailable = true
        data.totalCourses = 0
        data.completedCourses = 0
        data.inprogressCourses = 0
        data.notStartedCourses = 0

      },
      getCoursesFromFolder (folder) {
        let courses = []
        if(!folder.structure){
            return courses
        }
        let structure = JSON.parse(folder.structure)
        if (structure) {
          let recursionEntities = _.sortBy(structure, 'order')
          recursionEntities.forEach((item, i) => {
            if (item.entityType === 'deliverycontext' || item.entityType == 'catalog' || item.entityType === 'folder') {
              courses.push(item)
            }
          })
        }
        return courses
      },
      getTotalCourseCatalogs(entities) {
        let courses = []

        entities.forEach((item, i) => {
           if (item.entityType === 'folder') {
             if (item.structure) {
               let structure = JSON.parse(item.structure)
               if (structure) {
                 let recursionEntities = _.sortBy(structure, 'order')
                 let response = []
                 response = this.getTotalCourseCatalogs(recursionEntities)
                 courses.push(...response)
               }
             }
           } else {
             courses.push(item)
           }

        })

        return courses
      },

      getCoursesFromStructure(entities) {
        let courses = []

        entities.forEach((item, i) => {
           if (item.entityType === 'folder') {
             if (item.structure) {
               let structure = JSON.parse(item.structure)
               if (structure) {
                 let recursionEntities = _.sortBy(structure, 'order')
                 let response = []
                 response = this.getCoursesFromStructure(recursionEntities)
                 courses.push(...response)
               }
             }
           } else if (item.entityType === 'deliverycontext') {
             courses.push(item)
           }

        })

        return courses
      },
      aggregateProgressSummary (progressSummary) {
      },
      openAcademicProgressModal (doNotReset) {
        if (!doNotReset) {
          this.selectedProgram = null
          this.modalHeaderLabel = this.advisee.userName + '\'s Academic Progress for All Programs'
        }
        this.$refs.academicProgressModal.show()
      },
      showSelectedProgramProgress (data) {
        this.selectedProgram = data
        this.modalHeaderLabel = this.advisee.userName + '\'s Academic Progress for ' + data.programTitle
        this.$refs.academicProgressModal.show()
      },
      closeAcademicProgressModal () {
        this.$refs.academicProgressModal.hide()
      },
      statusClass (data) {
        if (data.score && !data.isScoreNotAvailable) {
          if (data.score >= 90) {
            return 'gradeA'
          } else if (data.score >= 80 && data.score < 90) {
            return 'gradeB'
          } else if (data.score >= 65 && data.score < 80) {
            return 'gradeC'
          } else if (data.score >= 40 && data.score < 65) {
            return 'gradeD'
          } else if (data.score < 40) {
            return 'gradeE'
          }
        } else {
          return 'noGrade'
        }
      },
      showBarTitle (count, status) {
        if (count > 1) {
          return count + ' courses are ' + status
        } else {
          return count + ' course is ' + status
        }
      },
      setThumbnailBgColor (uuid) {
        let numValue = uuid.replace(/[^0-9]/g, '')
        return '#' + numValue.slice((numValue.length - 8), (numValue.length - 2))
      },
      setThumbnailTitle (course) {
        if ((course.title.indexOf('-') !== -1) && (course.title.indexOf('-') < 7)) {
          let splitted = course.title.split('-')
          if (splitted.length > 0) {
            return splitted[0]
          }
        }
        return course.title.substring(0, 7)
      },
      millisToDate (millis) {
        if(millis){
          return 'on ' + DateTime.fromMillis(millis).toFormat('MM/dd/yyyy')
        }else{
            return ''
        }

      }

    },
    computed: {
      ...mapState({
        'enabledFeatures': state => state.institution.enabledFeatures,
        'userObj': state => state.user.userObj
      }),
      advisorDashboardFeature () {
        return this.enabledFeatures[PACKAGE.FEATURE_IDS.ADVISTOR_DASHBOARD_FEATURE_ID]
      },
      isProgramProgressEnabled () {
        let programDetail = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAM_DETAIL]
        if (programDetail) {
          let flags = programDetail.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'showProgramProgress') {
              return flags[i].enabled
            }
          }
        }
        return false
      },
      isReporcessEnrollmentEnabled () {
        let programDetail = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAM_DETAIL]
        if (programDetail) {
          let flags = programDetail.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'reprocessEnrollment') {
              return flags[i].enabled
            }
          }
        }
        return false
      },
      showCourseProgress () {
        let programDetail = this.enabledFeatures[PACKAGE.FEATURE_IDS.EXPLORE_PROGRAM_DETAIL]
        if (programDetail) {
          let flags = programDetail.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'showCourseProgress') {
              return flags[i].enabled
            }
          }
        }
        return false
      },

      isShowProgramName () {
        let advisorDashboardFeature = this.advisorDashboardFeature
        if (advisorDashboardFeature) {
          let flags = advisorDashboardFeature.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'showProgramNameWithLabel') {
              return flags[i].enabled
            }
          }
        }
        return false
      },
      majorLabel () {
        let advisorDashboardFeature = this.advisorDashboardFeature
        if (advisorDashboardFeature) {
          let flags = advisorDashboardFeature.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'showProgramNameWithLabel' && flags[i].label.length > 0) {
              return flags[i].label
            }
          }
        }
        return 'Program'
      },
      isShowCareerInterest () {
        let advisorDashboardFeature = this.advisorDashboardFeature
        if (advisorDashboardFeature) {
          let flags = advisorDashboardFeature.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'showCareerInterestWithLabel') {
              return flags[i].enabled
            }
          }
        }
        return false
      },
      careerLabel () {
        let advisorDashboardFeature = this.advisorDashboardFeature
        if (advisorDashboardFeature) {
          let flags = advisorDashboardFeature.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'showCareerInterestWithLabel' && flags[i].label.length > 0) {
              return flags[i].label
            }
          }
        }
        return 'Career Interest'
      },
      redirectStreamToProgressView () {
        let advisorDashboardFeature = this.advisorDashboardFeature
        if (advisorDashboardFeature) {
          let flags = advisorDashboardFeature.flags
          for (var i = 0; i < flags.length; i++) {
            if (flags[i].title === 'redirectStreamToProgressView') {
              return flags[i].enabled
            }
          }
        }
        return false
      },
      isCalendarEnabled () {
        let calendar = this.enabledFeatures[PACKAGE.FEATURE_IDS.CALENDAR]
        if (calendar && calendar.enabled) {
          return true
        }
        return false
      },
      isLearnerProfileEnabled () {
        let profileFeature = this.enabledFeatures[PACKAGE.FEATURE_IDS.PROFILE_FEATURE_ID]
        if (profileFeature && profileFeature.enabled) {
          let flags = profileFeature.flags
          let found = _.find(flags, (flag) => {
            return (flag.title === 'advisorCanAccessLearnerProfile')
          })
          return found ? found.enabled : false
        }
        return false
      }
    }
  }
</script>

<style>
  .popup_head_txt {
    color: #323232;
    font-weight: 800;
    font-size: 1.4rem;
    float: left;
    width: 98%;
  }

  .bg-academic-progress-popup-header {
    background: #eaf8ff !important;
  }

  .header-text {
    color: #fff;
    font-weight: 500;
    font-size: x-large;
    padding-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/app/adviseeTracker/components/LearnerCourses.vue